import { connect } from 'react-redux'

import {
  getCurrentProTrackProgressDay,
  getCurrentProTrackProgressLevelLength,
  getIdentityActiveProTrackWithLevelName,
} from 'store/entities/identity/selectors'

import ChartTitle from './ChartTitle'

const mapStateToProps = state => ({
  currentDay: getCurrentProTrackProgressDay(state),
  totalDays: getCurrentProTrackProgressLevelLength(state),
  proTrackNameWithLevelName: getIdentityActiveProTrackWithLevelName(state),
})

export default connect(mapStateToProps)(ChartTitle)
